import type { SVGProps } from 'react';
const SvgBrightnessAuto = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#brightness_auto_svg__a)">
      <path
        fill="currentColor"
        d="M10.85 12.65h2.3L12 9l-1.15 3.65ZM20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69ZM14.3 16l-.7-2h-3.2l-.7 2H7.8L11 7h2l3.2 9h-1.9Z"
      />
    </g>
    <defs>
      <clipPath id="brightness_auto_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgBrightnessAuto;
